
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop() public Controlador: ControladorBase;
        @Prop( { default: true } ) public MenuOpciones: boolean;
        @Prop( { default: false } ) public BreakPoint: boolean;
        @Prop( { default: false } ) public SinToolbar: boolean;

        mounted()
        {
            if ( this.BreakPoint || this.$vuetify.breakpoint.smAndDown )
                this.Controlador.Vista.Menu.Abierto = false;
        }

        Comprobar()
        {
//            if ( this.BreakPoint || this.$vuetify.breakpoint.smAndDown )
                this.Controlador.Vista.Menu.Abierto = false;
        }
    }
